export {
  KNOWN_NOTE_GENERATION_ERROR_CODES,
  NoteGenerationErrorCode,
} from '../../../contracts';

/**
 * Stream-generation failure. `message` is for `error.message === Code` branch
 * matching (and may be empty or a free-text `detail.msg`). `reason` is the
 * non-PHI diagnostic (`detail.type` or `HTTP_<status>`) that analytics/RUM
 * should read — never the free-text msg.
 */
export class FatalError extends Error {
  readonly reason?: string;
  constructor(message = '', reason?: string) {
    super(message);
    this.name = 'FatalError';
    this.reason = reason;
  }
}
